import React, { useState, useEffect } from "react";
import "./Preloader.css";
import logoImg from "../../assets/logo.png";

const Preloader = () => {
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFading(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`preloader-container ${isFading ? "fade-out" : ""}`}>
      <div className="preloader-content">
        <div className="logo-shine-wrapper">
          <img src={logoImg} alt="AceFund Loading" className="preloader-logo" />
        </div>
      </div>
    </div>
  );
};

export default Preloader;
